import { FC, ReactNode } from 'react';
import colors from '@styles/colors.module.scss';
import { Filter } from '@components/Filter';
import { Field } from '@components/Filter/types';
import { LoadingSpinner } from '@components/LoadingSpinner';
import { useGetUniversities } from './hooks/useGetUniversities';
import { useGetSpecialties } from './hooks/useGetSpecialties';
import { useGetForms } from './hooks/useGetForms';
import { useGetStatuses } from './hooks/useGetStatuses';

interface Props {
  onChange: (values: any) => void;
  filter: string[];
  hiddenFilterButtons?: ReactNode;
}

export const VacanciesFilter: FC<Props> = ({ onChange, filter, hiddenFilterButtons }) => {
  // Примерные данные — в будущем можно подгружать через хуки
  const { data: universities, isLoading } = useGetUniversities();
  const { data: specialities, isLoading: isLoadingSpecialities } = useGetSpecialties();
  const { data: forms, isLoading: isLoadingForms } = useGetForms();
  const { data: statuses, isLoading: isLoadingStatuses } = useGetStatuses();

  const trackedFields: Field[] = [
    {
      type: 'select',
      name: 'campusStatus',
      props: {
        placeholder: 'Статус в Кампусе',
        options: [
          { value: 'hidden', label: 'Скрыта' },
          { value: 'published', label: 'Опубликована' },
        ],
        sx: { width: '280px', background: colors.white },
      },
    },
    {
      type: 'select',
      name: 'responsesCount',
      props: {
        placeholder: 'Количество откликов',
        options: [
          { value: 'gt0', label: '> 0' },
          { value: 'eq0', label: '= 0' },
        ],
        sx: { width: '280px', background: colors.white },
      },
    },
    {
      type: 'select',
      name: 'hroomStatus',
      props: {
        placeholder: 'Статус в HRoom',
        options: [
          { value: 'archived', label: 'Архивная' },
          { value: 'published', label: 'Опубликована' },
        ],
        sx: { width: '280px', background: colors.white },
      },
    },
    {
      type: 'text',
      name: 'city',
      props: {
        placeholder: 'Город',
        sx: { width: '280px', background: colors.white },
      },
    },
    {
      type: 'text',
      name: 'company',
      props: {
        placeholder: 'Компания',
        sx: { width: '280px', background: colors.white },
      },
    },
    {
      type: 'select',
      name: 'universities',
      props: {
        multiple: false,
        options:
          universities
            ?.map(({ id, shortName }) => ({ label: shortName, value: id }))
            .sort((a, b) => a.label.localeCompare(b.label)) ?? [],
        placeholder: 'Требуемые университеты',
        sx: { width: '280px', background: colors.white },
      },
    },
    {
      type: 'select',
      name: 'specialties',
      props: {
        multiple: false,
        options:
          specialities
            ?.map(({ id, name }) => ({
              label: `${name}`,
              value: id,
            }))
            .sort((a, b) => a.label.localeCompare(b.label)) ?? [],
        placeholder: 'Требуемые специальности',
        sx: { width: '280px', background: colors.white },
      },
    },
    {
      type: 'select',
      name: 'studyForms',
      props: {
        multiple: false,
        options:
          forms
            ?.map(({ id, name }) => ({
              label: `${name}`,
              value: id,
            }))
            .sort((a, b) => a.label.localeCompare(b.label)) ?? [],
        placeholder: 'Форма обучения',
        sx: { width: '280px', background: colors.white },
      },
    },
    {
      type: 'select',
      name: 'studyStatus',
      props: {
        multiple: false,
        options:
          statuses
            ?.map(({ id, nameShort }) => ({
              label: `${nameShort}`,
              value: id,
            }))
            .sort((a, b) => a.label.localeCompare(b.label)) ?? [],
        placeholder: 'Статус обучения',
        sx: { width: '280px', background: colors.white },
      },
    },
  ];

  const filteredTrackedField = trackedFields.filter((el) => filter.includes(el.name));

  if (isLoading || isLoadingSpecialities || isLoadingForms || isLoadingStatuses) return <LoadingSpinner />;

  return (
    <Filter
      onChange={onChange}
      // searchField={{
      //   type: 'text',
      //   name: 'search',
      //   props: {
      //     placeholder: 'Поиск по всем полям вакансии',
      //     sx: { minWidth: '300px', background: colors.white },
      //   },
      // }}
      clearable={false}
      trackedFields={filteredTrackedField}
      hiddenFilterButton={hiddenFilterButtons}
      filter={filter}
    />
  );
};
